export default "__VITE_ASSET__4e028d22__"